import closeAllMenus from '../../core/INF-closeAllMenus';
import positionModal from './positionModal';
import resetModal from './resetModal';
import openShoppableImage from './openShoppableImage';
import initSlider from './initSlider';

export default (target, img) => {
  const modal = document.querySelector('[data-shoppable-image-modal]');
  const shoppableImagesUrl = `/pages/shoppable-image/${new Date().getTime()}/?products=${
    target.dataset.shoppableImage
  }&cache=false`;
  fetch(shoppableImagesUrl)
    .then((response) => response.text())
    .then((html) => {
      const tempDiv = document.createElement('div');
      tempDiv.classList.add('Model-content-new');
      tempDiv.innerHTML = html;
      const products = tempDiv.querySelectorAll('[data-products-content] [data-shoppable-product]');

      if (products.length < 1) {
        closeAllMenus();
        return;
      }

      resetModal();

      const modalImage = modal.querySelector('[data-shoppable-modal-image]');
      const imgElement = document.createElement('img');
      imgElement.src = img.src;
      imgElement.alt = img.alt;

      modalImage.appendChild(imgElement);
      modalImage.dataset.accentColor = target.dataset.accentColor;

      // Products go inside a scroll-snap viewport/track pair rather than
      // straight into the container. Flickity used to generate the equivalent
      // wrappers at init; the in-house carousel needs them authored. On desktop
      // both are `display: contents` (see ShoppableModal.scss) so the plain
      // scrolling product list is unchanged.
      const modalProducts = modal.querySelector('[data-shoppable-modal-products]');
      const viewport = document.createElement('div');
      viewport.className = 'ScrollCarousel__viewport';
      viewport.setAttribute('data-shoppable-modal-viewport', '');
      const track = document.createElement('div');
      track.className = 'ScrollCarousel__track';
      track.setAttribute('data-shoppable-modal-track', '');
      viewport.appendChild(track);
      modalProducts.appendChild(viewport);

      products.forEach((product) => {
        track.appendChild(product);
      });

      if (window.theme.breakpoints.current === 'mobile') {
        modalImage.style.backgroundColor = modalImage.dataset.accentColor;
      }

      // Need the timeout so the carousel measures a laid-out viewport height.
      setTimeout(() => {
        initSlider();
      }, 100);

      positionModal();
      openShoppableImage();
    });
};
